<template>
  <div class="p-3 border rounded bg-white">
      <div class="mb-3">
        <h5><strong>Vizualizare: Factura Fiscala</strong></h5>
        <div class="row">
          <div class="col-md-9">
            <table class="table table-bordered table-sm mb-3 bg-light">
              <thead>
                <tr class="table-success text-center">
                  <th>Client</th>
                  <th>Seria si nr. document</th>
                  <th>Data emiterii</th>
                  <th>Termen de plata</th>
                  <th>Sold</th>
                  <th>e-Factura</th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-center">
                  <td class="text-start">{{factura.c_denumire}}</td>
                  <td>{{factura.sd_serie}} {{factura.nr_doc}}</td>
                  <td>{{ this.formatDate(factura.data_doc) || '/' }}</td>
                  <td>{{ this.formatDate(factura.data_scadenta) || '/' }}</td>
                  <td>{{ formatCurrency(factura.isf_sold) || '0.00'}}</td>
                  <td>{{factura.efactura === 'Da' ? '<span class="badge bg-success">OK</span>' : '-'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <table class="table table-bordered table-sm mb-3 bg-light">
        <thead>
          <tr class="table-success text-center">
            <th></th>
            <th>Tip</th>
            <th>Denumire articol / serviciu</th>
            <th>UM</th>
            <th>TVA %</th>
            <th>Cantitate</th>
            <th>Pret unitar</th>
            <th>Valoare</th>
            <th>TVA</th>
            <th>Total</th>
            <th>Cont credit</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text-center" v-for="(prod, index) in produse" :key="index">
            <td>{{ prod.pozitie || '' }}</td>
            <td>
              <b>{{ prod.tp_abreviere_tip_produs }}</b> <small class="text-muted">({{ prod.tp_text }})</small>
            </td>
            <td class="text-start">{{ prod.denumire || '' }}</td>
            <td>{{ prod.unitate_masura || '' }}</td>
            <td>{{ prod.cota_tva || '' }}</td>
            <td>{{ prod.cantitate || '' }}</td>
            <td>{{ formatCurrency(prod.pret_unitar) || '0.00'}}</td>
            <td>{{ formatCurrency(prod.valoare) || '0.00'}}</td>
            <td>{{ formatCurrency(prod.tva) || '0.00'}}</td>
            <td>{{ formatCurrency(prod.total) || '0.00'}}</td>
            <td>{{ prod.cont_credit || '' }}</td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-between align-items-start w-100">
        <table class="table table-bordered table-sm mb-3 bg-light w-75">
          <thead>
            <tr class="table-success text-center">
              <th style="width: 75%">Informatii suplimentare</th>
              <th style="width: 25%">Descarcarea de gestiune</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-start">
                
              </td>
              <td> 
                <div class="cls_DOCw_tabeliesiri3_row_0_col_1_ck_cant_g_F">
                    <i class="fa fa-exclamation-circle fa-lg" aria-hidden="true" style="color: #a94442;"></i>
                    &nbsp;&nbsp;<span style="color: #a94442;">
                        <strong>Fara descarcarea de gestiune.</strong>
                    </span> 
                    Livrarea produselor si descarcarea gestiunii se fac pe baza Avizului de Insotire a Marfurilor</div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex flex-column justify-content-center align-items-end me-4" style="min-width: 300px;">
          <div style="font-size: 1.2rem;"><strong>Total fara TVA:</strong> {{ formatCurrency(factura.iesiri_date_valoare) || '0.00'}}</div>
          <div style="font-size: 1.2rem;"><strong>Total TVA:</strong> {{ formatCurrency(factura.iesiri_date_tva) || '0.00'}} </div>
          <hr class="w-100 my-2"/>
          <div style="font-size: 1.5rem; font-weight: bold;"><strong>Total:</strong> {{ formatCurrency(factura.iesiri_date_total) || '0.00'}}</div>
        </div>
      </div>
      <!-- Inserted Delegat Table Here -->
      <table class="table table-bordered table-sm mb-3 bg-light w-75">
        <thead>
          <tr class="table-success text-center">
            <th>Delegat</th>
            <th>CNP/Buletin delegat</th>
            <th>Auto</th>
            <th>Curs Valutar</th>
            <th>Intocmit de</th>
            <th>CNP</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text-center">
            <td>{{factura.delegat || '-'}}</td>
            <td>{{factura.delegat_cnp || '-'}}</td>
            <td>{{factura.delegat_auto || '-'}}</td>
            <td>{{factura.curs || '-'}}</td>
            <td>{{factura.nume || '-'}}</td>
            <td>{{factura.cnp || '-'}}</td>
          </tr>
        </tbody>
      </table>

      <!-- History -->
      <div v-if="history.length > 0" class="mt-4">
          <h6 class="text-primary mb-2"><i class="fas fa-history me-1"></i> <strong>Istoric Încasări:</strong></h6>
          <table class="table table-bordered table-sm mb-3 bg-white shadow-sm">
              <thead class="table-light">
                  <tr class="text-center align-middle">
                      <th>Data</th>
                      <th>Tip Document</th>
                      <th>Nr. Document</th>
                      <th>Explicații</th>
                      <th class="text-end">Sumă Încasată</th>
                      <th style="width: 80px;">Acțiuni</th>
                  </tr>
              </thead>
              <tbody>
                  <tr v-for="(h, idx) in history" :key="idx" class="text-center align-middle">
                      <td>{{ formatDate(h.data_incasare) }}</td>
                      <td>
                        <span class="badge bg-secondary">{{ h.tip_document }}</span>
                      </td>
                      <td>{{ h.numar_document || '-' }}</td>
                      <td class="text-start small text-muted">{{ h.explicatii }}</td>
                      <td class="text-end fw-bold text-success">{{ formatCurrency(h.suma_repartizata) }}</td>
                      <td>
                        <div class="d-flex justify-content-center">
                          <button class="btn btn-xs btn-outline-primary me-1 p-1 py-0" title="Editează" @click="handleEditIncasare(h)">
                            <i class="fas fa-edit"></i>
                          </button>
                          <button class="btn btn-xs btn-outline-danger p-1 py-0" title="Șterge" @click="handleDeleteIncasare(h)">
                            <i class="fas fa-trash"></i>
                          </button>
                        </div>
                      </td>
                  </tr>
              </tbody>
              <tfoot class="table-light fw-bold">
                  <tr>
                      <td colspan="4" class="text-end">Total Încasat:</td>
                      <td class="text-end text-success">{{ formatCurrency(totalIncasat) }}</td>
                      <td></td>
                  </tr>
              </tfoot>
          </table>
      </div>

      <!-- Footer Actions Toolbar -->
      <div class="d-flex align-items-center mt-4 border-top pt-3">
          <button class="btn btn-sm btn-light-primary me-3">
              <i class="fas fa-file-pdf me-1"></i> Descarca XML
          </button>
          <button class="btn btn-sm btn-light-success me-3">
              <i class="fas fa-check me-1"></i> Valideaza XML
          </button>
          
          <button class="btn btn-sm btn-danger me-3" @click="handleIncasare">
              <i class="fas fa-money-bill-wave me-1"></i> Incaseaza
          </button>
          
          <button class="btn btn-sm btn-light-primary" v-if="false">
              + Adauga Factura Noua
          </button>
      </div>
    </div>
</template>

<script>


export default {
    props: {
        factura: Object,
        produse: Array,
        onIncaseaza: Function,
        onEditIncasare: Function,
        onDeleteIncasare: Function
    },
    data() {
        return {
            setari_select2: {
                theme: 'bootstrap-5',
                placeholder: "Selectează din listă",
                width: "100%",
            },
            unitati_masura: [],
            history: []
        }
    },
    computed: {
        totalIncasat() {
            return this.history.reduce((acc, h) => acc + (parseFloat(h.suma_repartizata) || 0), 0);
        }
    },
    watch: {
        'factura.id': {
            immediate: true,
            handler() {
                this.loadHistory();
            }
        }
    },
    methods: {
        async loadHistory() {
            if (!this.factura || !this.factura.id) return;
            try {
                const response = await axios.get(`/api/facturare/incasari/history/${this.factura.id}`);
                this.history = response.data;
            } catch (e) {
                console.error("Eroare incarcare istoric incasari", e);
            }
        },
        handleIncasare() {
            if (typeof this.onIncaseaza === 'function') {
                this.onIncaseaza(this.factura);
            }
        },
        handleEditIncasare(incasare) {
            if (typeof this.onEditIncasare === 'function') {
                this.onEditIncasare(incasare);
            }
        },
        handleDeleteIncasare(incasare) {
            if (typeof this.onDeleteIncasare === 'function') {
                this.onDeleteIncasare(incasare);
            }
        },
        formatDate(date) {
          if (!date) return '/';
          return new Date(date).toLocaleDateString('ro-RO');
        },
        formatCurrency(value) {
          if(value) {
            var formatter = new Intl.NumberFormat('ro-RO', {
              style: 'currency',
              currency: 'Lei',
              currencyDisplay: 'symbol',
            });
            return formatter.format(value);
          }
        },
        incarcaUnitatiMasura(){
            axios.get('/api/facturare/utils/incarcaUnitatiMasura')
            .then((response) => {
                this.unitati_masura = response.data;
            });
        },
    },
    created(){

        //this.incarcaUnitatiMasura();
        
    },
};
</script>